var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 16.3659C12.9183 16.3659 16.5 12.7841 16.5 8.36585C16.5 3.94758 12.9183 0.365852 8.5 0.365852C4.08173 0.365852 0.5 3.94758 0.5 8.36585C0.5 12.7841 4.08173 16.3659 8.5 16.3659ZM6.78571 11.0801C6.39122 11.0801 6.07143 11.3999 6.07143 11.7944C6.07143 12.1889 6.39122 12.5087 6.78571 12.5087H10.2143C10.6088 12.5087 10.9286 12.1889 10.9286 11.7944C10.9286 11.3999 10.6088 11.0801 10.2143 11.0801H9.21429V7.79442C9.21429 7.39993 8.89449 7.08014 8.5 7.08014H7.35714C6.96265 7.08014 6.64286 7.39993 6.64286 7.79442C6.64286 8.18892 6.96265 8.50871 7.35714 8.50871H7.78571V11.0801H6.78571ZM9.64286 4.93728C9.64286 5.56846 9.13118 6.08014 8.5 6.08014C7.86882 6.08014 7.35714 5.56846 7.35714 4.93728C7.35714 4.3061 7.86882 3.79442 8.5 3.79442C9.13118 3.79442 9.64286 4.3061 9.64286 4.93728Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoWhite);
export default __webpack_public_path__ + "static/media/info_white.891d89292c8ea514013bfd908b83d06c.svg";
export { ForwardRef as ReactComponent };